import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Entry } from 'contentful';
import { SearchResult } from 'src/app/model/search/search-result';
import { Banner } from 'src/app/model/shared/banner';
import { ContentfulService } from 'src/app/service/contentful.service';
import { PageContentSearchService } from 'src/app/service/page-content-search.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-search-result-page',
  templateUrl: './search-result-page.component.html',
  styleUrls: ['./search-result-page.component.scss']
})
export class SearchResultPageComponent implements OnInit, AfterContentChecked {
  searchResults: SearchResult[] = [];
  displayResult: SearchResult[] = [];
  htmlTitle: string = '';
  searchNotFound: string = '';
  searchErrorLabel: string = '';
  inputValue = '';
  searchKeyword: string = 'id';
  filteredOptions: any[] = [];
  filterSearchData: any = [];
  isSearchLoaded: boolean = true;
  searchQuery: string = '';
  constructor(private contentfulService: ContentfulService, private pageContentSearchService: PageContentSearchService, private router: Router) {
    if (pageContentSearchService.cachedSearchResults.length === 0) {
      this.pageContentSearchService.fetchSearchResultsFromContentful().then(() => {
        this.isSearchLoaded = true;
      });
    }
    this.filteredOptions = this.pageContentSearchService.getSearchResultTitle();
  }
  banner: Banner = {} as Banner;
  /* pagination start */
  public pSettings = {
    start: 0,
    length: 20
  };
  public pNumberList: any = [];
  public lastPagination: number = 0;
  public beforeActivePage: number = 1;
  public afterActivePage: number = 1;
  /*end */
  ngAfterContentChecked(): void {
    if (this.isSearchLoaded) {
      this.searchResults = this.pageContentSearchService.returnAllContentfulSearchResults();
      this.isSearchLoaded = false;
    }
    this.getFilter();
  }
  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'search-result') {
        this.htmlTitle = title.htmlTitle;
      }
    });

    const query = { 'fields.title': 'Search' };
    this.contentfulService.getPageContentResponse(query).then((searchResultsPageEntry) => {
      this.mapBanner(searchResultsPageEntry.includes.Entry);
      this.mapSearchErrorfields(searchResultsPageEntry.items);
    });
  }

  private mapSearchErrorfields(labelItems: any) {
    this.searchErrorLabel = labelItems[0]?.fields.constants[0].searchNotFound;
    this.htmlTitle = labelItems[0].fields.htmlTitle;
  }
  getFilter() {
    this.pNumberList = [];
    this.displayResult = [];
    let data = this.searchResults;
    let totData = data.length;
    // let totData = 30;
    let startIndex = this.pSettings.start;
    let perPage = this.pSettings.length;
    let totBtn = totData / perPage;
    if (totBtn % 1 != 0) {
      totBtn = Math.round(totBtn);
    }
    let btnStart: any = 0;
    let btnEnd: any = 0;
    if (startIndex == 0) {
      btnEnd = this.afterActivePage + 2;
    } else {
      btnStart = startIndex - this.beforeActivePage;
      btnEnd = startIndex + this.afterActivePage + 1;
    }
    if (btnEnd >= totBtn) {
      if (totBtn > 3) {
        btnStart = totBtn - 3;
      } else {
        btnStart = 0;
      }
      btnEnd = totBtn;
    }
    if (totBtn > 1) {
      for (let i = btnStart; i < btnEnd; i++) {
        var row: any = {};
        row.label = i + 1;
        row.start = i;
        this.pNumberList.push(row);
        this.lastPagination = i;
      }
    } else {
      var row: any = {};
      row.label = 1;
      row.start = 0;
      this.pNumberList.push(row);
    }
    let startFrom = startIndex * perPage;
    let endTo = startFrom + perPage;
    for (let i = startFrom; i < endTo; i++) {
      if (typeof data[i] != 'undefined') {
        this.displayResult.push(data[i]);
      }
    }
  }
  updateStart(i: any) {
    this.pSettings.start = i;
    this.getFilter();
  }
  triggerPagination(type: 'back' | 'next') {
    let startIndex = this.pSettings.start;
    if (type == 'back') {
      if (startIndex != 0) {
        startIndex = startIndex - 1;
      }
    } else {
      if (startIndex != this.lastPagination) {
        startIndex = startIndex + 1;
      }
    }
    this.pSettings.start = startIndex;
    this.getFilter();
  }
  private mapBanner(searchResults: Entry<any>[]) {
    searchResults
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url as string
    };
  }

  search() {
    this.searchNotFound = '';
    this.searchResults = this.pageContentSearchService.getSearchResults(this.searchQuery);
    if (this.searchResults.length === 0) {
      this.searchNotFound = this.searchErrorLabel;
    }
  }

  onChangeSearch(search: string) {
    this.filterSearchData = [];
    this.filteredOptions = [...new Set(this.filteredOptions)];
    this.searchQuery = search;
    let sortList: any = this.filterItems(this.filteredOptions, search.toLowerCase());
    let sortListLength = sortList.length;
    if (sortListLength > 0) {
      this.filterSearchData = sortList;
    } else {
      let autoCorrectList: any = this.autoCorrect(this.filteredOptions, search.toLowerCase());
      this.filterSearchData = autoCorrectList;
    }
    this.search();
  }

  autoCorrect(tilteLists: any, searchValue: any) {
    let results: any = [];
    let searchValueArr = searchValue.split('');
    tilteLists.filter((tilteList: any) => {
      let isTitleMatch: boolean = false;
      let titleSplitBySpaces = tilteList.split(' ');
      let titleSplitBySpaceLength = titleSplitBySpaces.length;
      if (titleSplitBySpaceLength > 0) {
        titleSplitBySpaces.forEach((titleSplitBySpace: any) => {
          titleSplitBySpace = titleSplitBySpace.toLowerCase();
          let splitedTitlesSplitByHypen = titleSplitBySpace.split('-');
          let splitedTitlesSplitByHypenLength = splitedTitlesSplitByHypen.length;
          if (splitedTitlesSplitByHypenLength > 0) {
            splitedTitlesSplitByHypen.forEach((splitedTitleSplitByHypen: any) => {
              let hypenTitleArr: any = splitedTitleSplitByHypen.split('');
              if (hypenTitleArr[0] === searchValueArr[0]) {
                let finalDuplicateList = hypenTitleArr.filter((val: any) => {
                  return searchValueArr.indexOf(val) != -1;
                });
                finalDuplicateList = this.removeDuplicates(finalDuplicateList);
                let finalDuplicateLength = finalDuplicateList.length;
                if (finalDuplicateLength > 2) {
                  isTitleMatch = true;
                }
              }
            });
          }
        });
      }
      if (isTitleMatch) {
        results.push({ id: searchValue, title: tilteList });
      }
    });
    return results;
  }

  removeDuplicates(arr: any) {
    return arr.filter((item: any, index: any) => arr.indexOf(item) === index);
  }

  filterItems(arr: any, query: any) {
    let results: any = [];
    arr.filter((el: any) => {
      if (el.toLowerCase().includes(query.toLowerCase())) {
        results.push({ id: el, title: el });
      }
    });
    return results;
  }
}
